import React, { useContext, useState } from 'react';

import {
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';

import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import BreadCrumb from '../../fields/breadCrumb';
import ChangePasswordDialog from '../../modals/changePasswordDialog';
import ClinicianDetails from './clinicianDetails';
import CustomSnackbar from '../../feedback/customSnackbar';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawer from '../../fields/menuDrawer';
// import SpinnerLoading from '../../feedback/spinnerLoading';

// import { getClinicianInfo } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import { sectionTitle } from '../../../styles/formElementsStyles';

import generalStyles from '../../../styles/generalStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function EditClinicianInfo({ lang, handleChangeLang, type }) {
  const sessionContext = useContext(SessionContext);

  const [showDrawer, setShowDrawer] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackType, setFeedbackType] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState('');

  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  const history = useHistory();
  const { idClinician } = useParams();


  const gotoScreen = (screen) => {
    history.push(`/${sessionContext.role.toLowerCase()}/${screen}`);
  };

  const manageChangePasswordAnswer = () => {
    setShowChangePassword(false);
  };

  const manageFeedback = (fbType, fbMessage) => {
    setFeedbackMessage(translations[`_${fbType}${fbMessage}`]);
    setFeedbackType(fbType);
    setShowFeedback(true);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  return (
    <div className={classes.content}>
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawer type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} handleGotoScreen={(screen) => gotoScreen(screen)} />
      <CustomSnackbar show={showFeedback} handleCloseFeedback={(show) => setShowFeedback(show)} type={feedbackType} message={(showFeedback && feedbackMessage) || ''} />
      {type !== 'new' && (
        <ChangePasswordDialog open={showChangePassword} idUser={idClinician} handleClose={() => manageChangePasswordAnswer()} handleFeedback={(fbType, fbMessage) => manageFeedback(fbType, fbMessage)} title={translations['_changePasswordDialogTitle']} />
      )}
      <div className={classes.body}>
        <Grid container spacing={2} justify='space-around'>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            <BreadCrumb role={sessionContext.role.toLowerCase()} home='listClinicians' lang={lang} />
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item xs={11} className={sectionTitleStyle.root}>
            <Grid container justify='flex-start'>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{type === 'new' ? translations['_newClinicianData'] : translations['_editClinicianData']}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item xs={11}>
            <Grid container component={Paper} justify='flex-start' alignItems='flex-end' spacing={4}>
              <ClinicianDetails type={type} detailsData={type === 'edit' ? sessionContext.userData : {}} handleFeedback={(fbType, fbMessage) => manageFeedback(fbType, fbMessage)} handleShowChangePassword={() => setShowChangePassword(true)} />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(EditClinicianInfo);

// Indica i controla els props que se han de passar al component
EditClinicianInfo.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
